import styled from 'styled-components';
import { spacing, containers } from '@comicrelief/component-library';

const Wrapper = styled.div`
  background: ${({ theme }) => theme.color('grey_light')};
  display: flex;
  flex-direction: column;
`;

const Container = styled.article`
  background: ${({ theme }) => theme.color('white')};
  width: 100%;
  max-width: ${containers.small};
  margin: ${spacing('l')} auto;
  padding: ${spacing('l')} ${spacing('xl')};
`;

const Header = styled.header`
  padding-top: ${spacing('l')};
  text-align: center;
  width: 100%;
  max-width: ${containers.small};
  margin: 0 auto;
`;

const Image = styled.div`
  width: 100%;
  margin: ${spacing('l')} auto;

  @media ${({ theme }) => theme.allBreakpoints('L')} {
    width: 130%;
    margin-left: -15%;
  }
`;

const Body = styled.div`
  width: 100%;
  word-break: break-word;
`;

export {
  Wrapper, Container, Header, Image, Body
};
